import React from "react";

const Section2Acceptance = () => (
  <>
    <h2>2. Acceptance of Terms</h2>
    <p>
    Please read these Terms carefully before using the Service. By accessing or using any part of Comparedly.com, you signify your acceptance of these Terms and any amendments thereto. These Terms apply to all users of the Service, including individuals and organizations. Your continued use of the Service following the posting of any changes to these Terms constitutes acceptance of those changes. If at any point you do not agree to abide by these Terms, you must immediately cease all use of the Service.
    </p>
  </>
);

export default Section2Acceptance;
